// @flow
import * as React from "react";
import { useSelector } from "react-redux";
import { isMultiplasMedidasSelecionadas } from "../../util";
import AdicionarMedida from "./AdicionarMedida";
import { getGeradorMedidasSelecionadas } from "./modosExibicao/ModoExibicao";

import {
  type ModoApp,
  MODO_APP_SERIES,
  GRUPAMENTO_MEDIDAS_SERIES,
  GRUPAMENTO_MEDIDAS_QUANTITATIVAS,
  GRUPAMENTO_MEDIDAS_EMPRESAS,
  MODO_EXIBICAO_MEDIDA_QUALITATIVA,
} from "../../model";

import {
  getIndiceMedidaEditada,
  getMedidaSelecionada,
  getTipoCalculoSelecionado,
} from "../../state";

import { connectMedidas } from "./utils";
import {
  isMedidaOuSecundariasComEscalaMoeda,
  isMedidaOuSecundariasComCasasDecimais,
} from "../../model";

import "./area-edicao-medidas.css";

const MODOS_EXIBICAO_COM_CONFIGURACOES_DE_PERIODO_SOMENTE = [
  "ACOES_PONTUAL_DIARIO",
  "PONTUAL_CARTEIRA",
  "PONTUAL_DIARIO",
  "PONTUAL_DIARIO_SEM_PERIODICIDADE",
  "PONTUAL_MENSAL",
  "SERIES_COM_FONTE",
  "PERIODO_DIARIO_SEM_PERIODICIDADE",
];

type Props = {
  exibirEdicao: boolean,
  grupamentoMedidaSelecionado: string,
  modoExibicaoSelecionado: ?any,
  modoApp: ModoApp,
  exibirConfiguracoesAvancadas: Boolean,
};

function AreaAdicionarMedidas({
  grupamentoMedidaSelecionado,
  exibirEdicao,
  modoExibicaoSelecionado,
  modoApp,
  exibirConfiguracoesAvancadas,
}: Props) {
  const indiceMedidaEditada = useSelector(getIndiceMedidaEditada);
  const medidaSelecionada = useSelector(getMedidaSelecionada);
  const tipoCalculoSelecionado = useSelector(getTipoCalculoSelecionado);

  const geradorMedidasSelecionadas = useSelector(getGeradorMedidasSelecionadas);

  if (!modoExibicaoSelecionado) return null;

  const mostrarConfiguracoesAvancadas =
    modoApp === MODO_APP_SERIES &&
    grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_SERIES &&
    exibirConfiguracoesAvancadas;

  const mostrarEspacamento = modoApp !== MODO_APP_SERIES;

  const grupamentosComPersonalizacao =
    (grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_SERIES ||
      grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_QUANTITATIVAS ||
      grupamentoMedidaSelecionado === GRUPAMENTO_MEDIDAS_EMPRESAS) &&
    !exibirConfiguracoesAvancadas;

  const exibicaoPeriodoSemCasaDecimalEscalaMoeda =
    MODOS_EXIBICAO_COM_CONFIGURACOES_DE_PERIODO_SOMENTE.includes(
      modoExibicaoSelecionado
    ) &&
    !isMedidaOuSecundariasComCasasDecimais(medidaSelecionada) &&
    !isMedidaOuSecundariasComEscalaMoeda(
      medidaSelecionada,
      tipoCalculoSelecionado
    );

  const foraDaTelaSeriesEMedidaQualitativa =
    modoApp !== MODO_APP_SERIES &&
    isMultiplasMedidasSelecionadas(medidaSelecionada) &&
    modoExibicaoSelecionado !== MODO_EXIBICAO_MEDIDA_QUALITATIVA;

  const medidaQualitativaForaTelaSeries =
    modoApp !== MODO_APP_SERIES &&
    modoExibicaoSelecionado === MODO_EXIBICAO_MEDIDA_QUALITATIVA;

  return (
    <>
      {(modoApp === MODO_APP_SERIES &&
        (grupamentosComPersonalizacao ||
          exibicaoPeriodoSemCasaDecimalEscalaMoeda)) ||
      medidaQualitativaForaTelaSeries ||
      foraDaTelaSeriesEMedidaQualitativa ? (
        <AdicionarMedida
          geradorMedidasSelecionadas={geradorMedidasSelecionadas}
          mostrarConfiguracoesAvancadas={mostrarConfiguracoesAvancadas}
          mostrarEspacamento={mostrarEspacamento}
        />
      ) : (
        <div className="AreaEdicaoMedidas__configuracoes-edicao">
          <AdicionarMedida
            geradorMedidasSelecionadas={geradorMedidasSelecionadas}
            mostrarConfiguracoesAvancadas={mostrarConfiguracoesAvancadas}
            mostrarEspacamento={mostrarEspacamento}
            novaMedida={false}
          />
          {indiceMedidaEditada !== null && (
            <div className="nova-medida">
              <AdicionarMedida
                geradorMedidasSelecionadas={geradorMedidasSelecionadas}
                mostrarConfiguracoesAvancadas={mostrarConfiguracoesAvancadas}
                mostrarEspacamento={mostrarEspacamento}
                novaMedida={true}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default connectMedidas()(AreaAdicionarMedidas);
